import { render, staticRenderFns } from "./EmiratesIDDetails.vue?vue&type=template&id=761609d8"
import script from "./EmiratesIDDetails.vue?vue&type=script&lang=js"
export * from "./EmiratesIDDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports